import { EncryptStorage } from 'encrypt-storage'
import { appConfig } from 'src/constants'

export const encryptStorage = new EncryptStorage(appConfig.TENANT, {
  storageType: 'localStorage', // or 'sessionStorage'
  prefix: '@secure',
})
